import React from "react";

import * as ListItem from "../ListItem";
import styles from "../styles.module.css";

function WithTimestampOnTop(props: ListItem.Props) {
  const { description, timestamp } = props;

  return (
    <article className={styles.listItemContainer}>
      <div className={styles.mainColumn} data-skeleton-selector>
        {timestamp && <ListItem.Timestamp {...props} />}
        <ListItem.Text {...props} />
        {description && <ListItem.Description {...props} />}
      </div>
    </article>
  );
}
WithTimestampOnTop.displayName = "WithTimestampOnTop.Component";

export { WithTimestampOnTop };

export * from "./Themed";
